export default __webpack_public_path__ + "static/coupon1bg-77ea895154f1c183eac9da68239987c6-42df6c17ddec5b67dfffaac2ecaad014.png";